import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { debounceTime, filter, distinctUntilChanged } from 'rxjs/operators';
import { MDBDatePickerComponent, ToastService } from 'ng-uikit-pro-standard';
import { DireccionService } from 'src/app/services/direccion.service';
import { DocumentoService, IFechaVencimientoQueryParams } from 'src/app/services/documento.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { VendedorRubroClienteService } from 'src/app/services/vendedor-rubro-cliente.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { CondicionPagoService } from 'src/app/services/condicion-pago.service';
import { VendedorService } from 'src/app/services/vendedor.service';
import { unidad_negocio } from 'src/app/shared/object/unidad_negocio.model';
import { ModalDocsReferenciaComponent } from 'src/app/views/shared/modal-docs-referencia/modal-docs-referencia.component';
import { ModalSeleccionarProveedorComponent } from 'src/app/views/shared/modal-seleccionar-proveedor/modal-seleccionar-proveedor.component';

@Component({
  selector: 'app-factura-terceros-cabecera',
  templateUrl: './factura-terceros-cabecera.component.html',
  styleUrls: ['./factura-terceros-cabecera.component.scss'],
  providers: [SecurityService],
})
export class FacturaTercerosCabeceraComponent implements OnInit {
  @Input() permiteUnidadNegocio: boolean = false;
  @Input() optionsUnidadesDeNegocio: unidad_negocio[] = [];

  @Output() onProveedorChange: EventEmitter<any> = new EventEmitter<any>();

  // Modales
  @ViewChild(ModalDocsReferenciaComponent, { static: true }) modalDocsReferencias: ModalDocsReferenciaComponent;
  @ViewChild('datePicker', { static: true }) datePickerFechaDoc: MDBDatePickerComponent;
  @ViewChild(ModalSeleccionarProveedorComponent, { static: true }) modalSeleccionarProveedor: ModalSeleccionarProveedorComponent;

  // Form
  formHeader: FormGroup;

  // Data &  Tmp
  proveedorSeleccionado: any = null;
  private rutEmpresa: number;
  private sucursalEmpresa: number;
  enableClient: boolean = true;
  optionsSucursal: Array<any> = [];
  optionsVendedor: Array<any> = [];
  optionsCondicionPago: Array<any> = [];
  headerData: any = {};
  private isCleaningUp: boolean = false;
  CountListDocRef: number = 0;
  documentRef: Array<any> = [];

  // public getters
  get cliente() {
    if (!this.headerData) return null;
    return this.headerData.clienteSeleccionado;
  }

  // Utils
  private log: any;

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private rutService: RutService,
    private direccionService: DireccionService,
    private vendedorService: VendedorService,
    private vendedorRubroClienteService: VendedorRubroClienteService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private documentoService: DocumentoService,
    private datesService: DatesService,
    private formValidatorsService: FormValidatorsService,
    private condicionPagoService: CondicionPagoService
  ) {
    this.log = this.clog.log('CABECERA');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());

    this.fetchCondicionPago();
    this.createForms();
    this.formChangesSubscriptions();
  }

  private fetchCondicionPago() {
    const inputParams = {
      rut_empresa: this.rutEmpresa,
      sucursal_codigo: this.sucursalEmpresa,
      tipobusqueda: 1,
    };

    this.log('fetch condición pago', JSON.stringify(inputParams));
    this.condicionPagoService.obtenerSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros } = respuesta;
      this.optionsCondicionPago = registros.map((condicionPago) => ({
        value: condicionPago.codigo,
        label: condicionPago.descripcion,
        ...condicionPago,
      }));

      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('condicionPago'), this.optionsCondicionPago);
    });
  }

  private createForms() {
    this.formHeader = this.fb.group({
      unidad_negocio_codigo: [null, [Validators.required]],
      rut: [null, [Validators.required]],
      sucursal: [null, [Validators.required]],
      condicionPago: [null, [Validators.required]],
      fechaDesde: [null, [Validators.required]],
      fechaHasta: [null, [Validators.required]],
    });
  }

  private formChangesSubscriptions() {
    this.formHeader
      .get('rut')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rut: string) => {
        this.modalSeleccionarProveedor.searchByRut(rut);
      });

    this.formHeader.get('fechaDesde').valueChanges.subscribe((fecha) => this.handleFechaFacturaChange(fecha));
    this.formHeader.get('sucursal').valueChanges.subscribe((direccion) => this.handleDireccionChange(direccion));
    this.formHeader.get('condicionPago').valueChanges.subscribe((condicionPago) => {
      if (!condicionPago) {
        this.log('condicionPago change', condicionPago);
        if (this.headerData && this.headerData.fechaVencimiento) this.headerData.fechaVencimiento = null;
      } else this.fetchFechaVencimiento();
    });
  }

  private fetchSucursal(cliente_proveedor_rut) {
    const inputParams = {
      empresa_rut: this.rutEmpresa,
      // sucursal_codigo: this.sucursalEmpresa,
      cliente_proveedor_rut,
    };

    this.log('fetch sucursal', JSON.stringify(inputParams));
    this.direccionService.GetByCliente(inputParams, ({ registros }) => {
      this.optionsSucursal = registros.map((direccion) => ({
        value: direccion.codigo,
        label: direccion.direccion_completa,
        ...direccion,
      }));
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('sucursal'), this.optionsSucursal);
    });
  }

  private handleDireccionChange(value) {
    this.log('handleDireccionChange', value);
    if (!this.proveedorSeleccionado || !this.optionsSucursal) return;

    this.headerData.direccion = this.optionsSucursal.filter((p) => p.value === value)[0];

    // this.log('this.headerData.direccion', this.headerData.direccion)
    // this.fetchVendedorByDefautByCliente(this.headerData.clienteSeleccionado.rut, this.headerData.direccion.codigo);

    // this.log('dirección', this.headerData.direccion)
    // this.log('lista cond.Pago', this.optionsCondicionPago)
    // obtener la sucursal seleccionada
    // const sucursalSeleccionada = this.optionsSucursal.filter(p => p.codigo === value)
    // if (sucursalSeleccionada && sucursalSeleccionada.length > 0) {

    // set default condicionPago
    // condicion_pago_codigo
    // const condicionPagoSucursal = this.optionsCondicionPago.filter((p) => p.codigo === this.headerData.direccion.condicion_pago_codigo);
    // if (condicionPagoSucursal && condicionPagoSucursal.length > 0) this.formHeader.get('condicionPago').setValue(condicionPagoSucursal[0].value);
    // }
    // this.fetchFechaVencimiento()
  }

  abrirModalSeleccionarProveedor() {
    this.modalSeleccionarProveedor.show();
  }

  // private limpiarDataSeleccionada() {
  //   this.headerData = {};
  // }

  onProveedorSeleccionado({ data, origen }) {
    this.proveedorSeleccionado = data;
    this.headerData.clienteSeleccionado = this.proveedorSeleccionado;
    this.proveedorSeleccionado.rutFormato = this.rutService.AgregarDV(this.proveedorSeleccionado.rut);
    this.formHeader.get('rut').setValue(this.proveedorSeleccionado.rutFormato);
    this.formHeader.get('fechaDesde').setValue(this.datesService.CurrentDateToShortTimeString());
    this.onProveedorChange.emit(this.proveedorSeleccionado);
    this.fetchSucursal(this.proveedorSeleccionado.rut);
  }

  onProveedorNoEncontrado() {
    this.proveedorSeleccionado = null;
    this.clearProveeData();
  }

  clearProveeData() {
    this.clearContent();
    this.onProveedorChange.emit(null);
  }

  private handleFechaFacturaChange(fecha) {
    this.headerData.fechaVencimiento = null;
    if (!fecha)
      // TODO Validar que sea fecha válida
      return;
    this.fetchFechaVencimiento();
  }

  private fetchFechaVencimiento() {
    this.headerData.fechaVencimiento = null;
    this.log('fetchFechaVencimiento', this.formHeader.get('fechaDesde').value, this.formHeader.get('condicionPago').value, this.headerData);
    if (
      !this.headerData ||
      // !this.headerData.clienteSeleccionado ||
      // !this.headerData.direccion ||
      !this.formHeader.get('fechaDesde').value ||
      !this.formHeader.get('condicionPago').value
    )
      return;

    const inputParams: IFechaVencimientoQueryParams = {
      rut_empresa: this.rutEmpresa,
      sucursal_codigo: this.sucursalEmpresa,
      cliente_proveedor_rut: 0,
      // direccion_codigo: this.headerData.clienteSeleccionado.codigo_direccion,
      direccion_codigo: 0,
      fecha_documento: this.formHeader.get('fechaDesde').value,
      condicion_pago_codigo: this.formHeader.get('condicionPago').value,
    };

    this.log('fetchFechaVencimiento', JSON.stringify(inputParams));
    this.documentoService.ObtenerFechaVencimiento(inputParams, ({ mensajes, respuesta }) => {
      this.headerData.fechaVencimiento = respuesta.fecha_vencimiento;
      this.formHeader.get('fechaHasta').setValue(this.headerData.fechaVencimiento);
    });
  }

  validate() {
    // this.log('descuento.porcentaje', this.formHeader.get('descuento.porcentaje').valid)
    // this.log('descuento.monto', this.formHeader.get('descuento.monto').valid)
    // this.log('recargo.porcentaje', this.formHeader.get('recargo.porcentaje').valid)
    // this.log('recargo.monto', this.formHeader.get('recargo.monto').valid)

    const unidad_negocio_codigo_state = this.formHeader.get('unidad_negocio_codigo').enabled;
    this.formHeader.get('unidad_negocio_codigo').enable();

    // Add/Remove unidad_negocio_codigo validators
    if (this.permiteUnidadNegocio) {
      this.formHeader.get('unidad_negocio_codigo').setValidators([Validators.required]);
    } else {
      this.formHeader.get('unidad_negocio_codigo').setValidators([]);
    }
    this.formHeader.get('unidad_negocio_codigo').updateValueAndValidity();

    const valid = this.formValidatorsService.validate(this.formHeader);
    if (!unidad_negocio_codigo_state) this.formHeader.get('unidad_negocio_codigo').disable();
    return valid;
  }

  getHeaderData() {
    // this.documentRef.map(x=> {
    //   delete x.checked
    //   delete x.index
    // })

    return {
      unidad_negocio_codigo: this.formValidatorsService.obtenerValorFormHeader(this.formHeader, 'unidad_negocio_codigo'),
      cliente: this.cliente,
      fechaFactura: this.formHeader.get('fechaDesde').value,
      fechaVencimiento: this.formHeader.get('fechaHasta').value,
      sucursal: this.optionsSucursal.filter((p) => p.value === this.formHeader.get('sucursal').value)[0],
      condicionPago: this.formHeader.get('condicionPago').value,
    };
  }

  disableHeader(tipo: 'LIBRE' | 'NO_FACTURABLE' | 'NORMAL') {
    this.enableClient = false;
    // this.formHeader.get('facturaAfectaOrExcenta').disable();
    this.formHeader.get('sucursal').disable();
    this.formHeader.get('condicionPago').disable();
    // this.formHeader.get('vendedor').disable();
    // if (tipo === 'NORMAL')
    this.formHeader.get('unidad_negocio_codigo').disable();
  }

  enableContent() {
    this.enableClient = true;
    // this.formHeader.get('facturaAfectaOrExcenta').enable();
    this.formHeader.get('sucursal').enable();
    this.formHeader.get('condicionPago').enable();
    // this.formHeader.get('vendedor').enable();
    this.formHeader.get('unidad_negocio_codigo').enable();
  }

  //MOSTRAR CONTADOR DE DOCS REFERENCIAS
  getCountListDocRef($event) {
    this.CountListDocRef = $event.length;
    this.documentRef = $event;
  }

  clearContent() {
    this.CountListDocRef = null;
    this.documentRef = [];
    this.isCleaningUp = true;
    this.enableContent();
    this.optionsSucursal = [];
    // this.optionsVendedor = [];
    this.headerData = {};
    this.datePickerFechaDoc.clearDate();

    this.formValidatorsService.reset(this.formHeader);
    this.proveedorSeleccionado = {};
    this.formHeader.get('sucursal').setValue(null);
    this.formHeader.get('fechaDesde').setValue(null);
    this.formHeader.get('fechaHasta').setValue(null);

    this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('condicionPago'), this.optionsCondicionPago);

    this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('vendedor'), this.optionsVendedor);

    setTimeout(() => {
      this.formHeader.get('fechaDesde').setValue(null);
    }, 500);

    setTimeout(() => {
      this.formHeader.get('fechaHasta').setValue(null);
    }, 1000);

    this.log('clearContent headerData', this.headerData);

    setTimeout(() => {
      this.isCleaningUp = false;
    }, 1000);
  }

  disableUnidadNegocio(unidad_negocio_codigo: number | null) {
    if (unidad_negocio_codigo) this.formHeader.get('unidad_negocio_codigo').setValue(unidad_negocio_codigo);
    this.formHeader.get('unidad_negocio_codigo').disable();
  }
}
